export const AGENT_INFO_ROUTE = '/api/client/agent/agent-info';
export const AGENT_INFO_GET = 'AGENT_INFO_GET';
export const AGENT_INFO_GET_LOADING = 'AGENT_INFO_GET_LOADING';

export const UTILITIES_TIMEZONES_ROUTE = '/api/utilities/timezones';
export const UTILITIES_TIMEZONES_GET = 'UTILITIES_TIMEZONES_GET';
export const UTILITIES_REPORT_COLUMNS_ROUTE = '/api/client/agent/report-columns';
export const UTILITIES_REPORT_COLUMNS_GET = 'UTILITIES_REPORT_COLUMNS_GET';
export const UTILITIES_REPORT_COLUMNS_GET_LOADING = 'UTILITIES_REPORT_COLUMNS_GET_LOADING';
export const UTILITIES_TUNE_ADVERTISERS_BY_AGENT_ROUTE = '/api/client/agent/advertisers-by-agent';
export const UTILITIES_TUNE_ADVERTISERS_BY_AGENT_GET = 'UTILITIES_TUNE_ADVERTISERS_BY_AGENT_GET';
export const UTILITIES_TUNE_PUBLISHER_BY_AGENT_ROUTE = '/api/client/agent/publisher-by-agent';
export const UTILITIES_TUNE_PUBLISHER_BY_AGENT_GET = 'UTILITIES_TUNE_PUBLISHER_BY_AGENT_GET';

export const REPORTS_ADVERTISER_COMMISSION_REPORT_ROUTE = '/api/client/agent/advertiser-commission-report';
export const REPORTS_ADVERTISER_COMMISSION_REPORT_GET = 'REPORTS_ADVERTISER_COMMISSION_REPORT_GET';
export const REPORTS_ADVERTISER_COMMISSION_REPORT_GET_LOADING = 'REPORTS_ADVERTISER_COMMISSION_REPORT_GET_LOADING';
export const REPORTS_PUBLISHER_COMMISSION_REPORT_ROUTE = '/api/client/agent/publisher-commission-report';
export const REPORTS_PUBLISHER_COMMISSION_REPORT_GET = 'REPORTS_PUBLISHER_COMMISSION_REPORT_GET';
export const REPORTS_PUBLISHER_COMMISSION_REPORT_GET_LOADING = 'REPORTS_PUBLISHER_COMMISSION_REPORT_GET_LOADING';
